import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.GATSBY_BASE_URL}`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
